import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5e794a86&scoped=true&"
import script from "./Dashboard.ts?vue&type=script&lang=ts&"
export * from "./Dashboard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e794a86",
  null
  
)

export default component.exports
import {QTabs,QTab,QBadge,QTabPanels,QTabPanel,QDrawer,QBar,QSpace,QBtn} from 'quasar'
component.options.components = Object.assign({QTabs,QTab,QBadge,QTabPanels,QTabPanel,QDrawer,QBar,QSpace,QBtn}, component.options.components || {})
